import { Link } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";

const COLS = [
  {
    title: "Label Croppers",
    links: [
      { label: "Amazon Label Crop", path: "/tools/amazon-shipping-label-crop" },
      { label: "Flipkart Label Crop", path: "/tools/flipkart-shipping-label-crop" },
      { label: "Meesho Label Crop", path: "/tools/meesho-shipping-label-crop" },
      { label: "Shopsy Label Crop", path: "/tools/shopsy-shipping-label-crop" },
    ],
  },
  {
    title: "PDF & Layout",
    links: [
      { label: "PDF Shipping Label Cropper", path: "/tools/pdf-shipping-label-cropper" },
      { label: "Merge Marketplace Labels", path: "/tools/merge-marketplace-labels" },
      { label: "A4 Label Maker", path: "/tools/a4-label-maker" },
      { label: "Invoice Cropper", path: "/tools/invoice-cropper" },
      { label: "Merge PDF", path: "/tools/merge-pdf" },
      { label: "Rearrange PDF", path: "/tools/rearrange-pdf" },
      { label: "Profit Calculator", path: "/profit-calculator" },
    ],
  },
  {
    title: "Image & AI Tools",
    links: [
      { label: "Product Image Resizer", path: "/tools/product-image-resizer" },
      { label: "Amazon Image Resizer", path: "/tools/amazon-product-image-resizer" },
      { label: "Meesho Image Resizer", path: "/tools/meesho-product-image-resizer" },
      { label: "Title Generator", path: "/ai-tools/product-title-generator" },
      { label: "Description Generator", path: "/ai-tools/product-description-generator" },
      { label: "Seller Guides (Blog)", path: "/blog" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Logo textClass="text-white" />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Smart, free tools for e-commerce sellers. Crop shipping labels, tidy up PDFs and write better listings — right in your browser.
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-xs text-slate-400">
              <ShieldCheck className="w-4 h-4 text-blue-400" /> PDF tools run on your device
            </p>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-semibold text-white mb-3">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l.path}>
                    <Link to={l.path} className="text-sm text-slate-400 hover:text-blue-400 transition-colors" data-testid={`footer-link-${l.path}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-center sm:text-left">
            <p className="text-xs text-slate-500">© {new Date().getFullYear()} Ecroply AI. All tools are free. No account needed.</p>
            <Link to="/privacy-policy" data-testid="footer-privacy" className="text-xs text-slate-400 hover:text-blue-400">Privacy Policy</Link>
          </div>
          <a href="mailto:support@ecroply.ai" data-testid="footer-contact" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-blue-400">
            <Mail className="w-4 h-4" /> support@ecroply.ai
          </a>
        </div>
      </div>
    </footer>
  );
}
